/**
 * Converts a Date instance to a string like 'September 9, 2021 at 9:09 AM'.
 * @param date a Date instance
 */
export const dateToDateAndTime = (date: Date): string => {
    const dateFormatter = new Intl.DateTimeFormat('en', {
        calendar: 'gregory',
        dateStyle: 'long',
        timeStyle: 'short',
    });

    return dateFormatter.format(date);
};
